module.exports = __webpack_public_path__ + "img/Yonah.94ac40e0.png";